<script lang="ts">
	import { t } from "@hitit/hub/src/stores";
	import { OutlineButton, PopperIcon } from "@hitit/new_ui";

	type Props = {
		textTranslation: string;
		accept: () => void;
		cancel: () => void;
		imageSrc?: string;
		subText?: string;
	};

	export let props: Props = {
		textTranslation: "",
		accept: () => {},
		cancel: () => {},
		imageSrc: "",
		subText: "",
	};
</script>

<div class="container">
	<img
		src={props.imageSrc ? props.imageSrc : "/img/icons/warning.png"}
		alt="warning icon"
	/>
	<p>
		{@html $t(props.textTranslation)}
	</p>
	{#if props.subText}
		<div class="sub-text-image">
			<div class="icon">
				<PopperIcon fill={"#bcbfc3"} />
			</div>
			<p class="sub-text">{props.subText}</p>
		</div>
	{/if}
	<div class="button-container">
		<OutlineButton noneBordercolor fitmode on:click={props.cancel}>
			<span class="cancel">{$t("global.cancel")}</span>
		</OutlineButton>
		<OutlineButton noneBordercolor fitmode on:click={props.accept}>
			<span class="accept">{$t("global.ok")}</span>
		</OutlineButton>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
		padding: 30px;
		background-color: rgba(#46474b, 0.9);
		box-sizing: border-box;
		min-width: 300px;
		border-radius: 5px;
		z-index: 100;
	}
	img {
		width: 30px;
		height: 30px;
	}
	p {
		text-align: center;
		color: #ffffff;
		line-height: 1.25rem;
	}
	.button-container {
		display: flex;
		justify-content: space-evenly;
		width: 100%;

		.cancel {
			color: #bcbfc3;
		}

		.accept {
			color: white;
		}
	}

	.sub-text-image {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 5px;

		.icon {
			width: 20px;
			height: 20px;
		}

		.sub-text {
			@include appleAdjustTextForSize(14, false);
			color: white;
			margin-bottom: 3px;
		}
	}

	@include DesktopSize {
		.container {
			min-height: 204px;
		}
		p {
			line-height: 1.875rem;
			font-size: 1.25rem;
		}

		span {
			font-size: 1.25rem;
		}
	}
</style>
